module.exports = __webpack_public_path__ + "static/img/14.e9f14e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/sp/14.png
// module id = 4Dx4
// module chunks = 0